import {toast} from 'react-toastify';
import React, {FC, useState} from 'react';
import {IDataCatalog, releaseDataCatalogVersion, VerdocsEndpoint} from '@verdocs/js-sdk';
import {Button, Spinner} from '../Components';
import {Dialog} from './Dialog';

interface ReleaseDataCatalogDialogProps {
  catalog: IDataCatalog;
  onClose: () => void;
  onReleased: () => void;
}

export const ReleaseDataCatalogDialog: FC<ReleaseDataCatalogDialogProps> = ({catalog, onClose, onReleased}) => {
  const [notes, setNotes] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const version = catalog.latest_version + 1;

  const handleRelease = () => {
    if (submitting) {
      return;
    }

    setSubmitting(true);
    releaseDataCatalogVersion(VerdocsEndpoint.getDefault(), catalog.organization_id, catalog.id, notes.trim() || undefined)
      .then(() => {
        setSubmitting(false);
        toast.success(`Released version ${version}`);
        onReleased();
      })
      .catch((e: any) => {
        setSubmitting(false);
        toast.error(`Error releasing the catalog: ${e.response?.data?.message || e.message}`);
      });
  };

  return (
    <Dialog onCancel={onClose}>
      <div className="text-lg font-medium text-[#33364b]">Release version {version}</div>
      <div className="mb-4 mt-0.5 text-[13px] text-gray-500">
        This freezes the live keys of {catalog.name}.{' '}
        {catalog.sharing === 'shared' ? 'Organizations that imported it get an update to review.' : 'It stays private until you share it.'}
      </div>

      <label className="mb-1 block text-[13px] font-medium text-[#33364b]">What changed</label>
      <textarea
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        rows={4}
        placeholder="Added wind coverage; renamed the premium label"
        className="w-full rounded-md border border-[#dcdee5] p-3 text-[13px] text-[#33364b] outline-none placeholder:text-gray-400 focus:border-[#654dcb]"
      />

      <div className="mt-4 flex flex-row items-center justify-end gap-2 border-t border-[#f2f3f5] pt-4">
        {submitting && <Spinner mode="dark" />}
        <Button type="button" size="small" variant="secondary" label="Cancel" onClick={onClose} disabled={submitting} />
        <Button size="small" label={`Release version ${version}`} onClick={handleRelease} disabled={submitting} />
      </div>
    </Dialog>
  );
};
